import React from 'react';
import { connect } from 'react-redux';
import Input from 'react-toolbox/lib/input';
import { Button, IconButton } from 'react-toolbox/lib/button';
import { create } from '~/actions/locations';
import styleDialog from '~/style/dialog.scss';

class Dialog extends React.Component {
  static contextTypes = {
    dialogClose: React.PropTypes.func.isRequired,
    apiClient: React.PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      name: '',
      parentId: (props.data && props.data.parentId) || '',
    };
  }

  submit() {
    create(this.props.dispatch, this.context.apiClient, this.state)
      .then(() => this.context.dialogClose(this.props.dialogId))
      .then(() => this.props.data.onCreate && this.props.data.onCreate());
  }

  render() {
    return (
      <div className={[styleDialog.background, styleDialog[this.props.transition]].join(' ')} onClick={() => this.context.dialogClose(this.props.dialogId)}>
        <div className={styleDialog.container} onClick={e => e.stopPropagation()}>
          <IconButton className={styleDialog.closeButton} icon="close" onClick={() => this.context.dialogClose(this.props.dialogId)} />
          <div className={styleDialog.content}>
            <form onSubmit={e => { e.preventDefault(); this.submit(); }}>
              <Input label="Name" required value={this.state.name} onChange={name => this.setState({ name })} />
              <Button label="Create" type="submit" primary raised />
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export default connect()(Dialog);



// WEBPACK FOOTER //
// ./app/dialogs/LocationNew/index.js